import { render, staticRenderFns } from "./overviewGroupCompany.vue?vue&type=template&id=686a160c&scoped=true"
import script from "./overviewGroupCompany.vue?vue&type=script&lang=js"
export * from "./overviewGroupCompany.vue?vue&type=script&lang=js"
import style0 from "./overviewGroupCompany.vue?vue&type=style&index=0&id=686a160c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686a160c",
  null
  
)

export default component.exports